<!-- 修改手机组件 -->
<template id="modify_phone">
  <section class="modify-phone">
    <steps :title="stepTitle" :step="currentStep"></steps>
    <div class="" :is="modify_view" :v_type="vType" :switch_enabled="true" :btn_text="btnText" :request="request" :finish_title="finish_title" :modify_type="stepTitle" @switchValidate="switchValidate" @next="next" @finish="finish" @errorResult="errorResult"></div>
  </section>
</template>

<script>
  import steps from './../steps.vue'
  import id_validate from './../id_validate.vue'
  import bind_phone from './bind_phone.vue'
  import finish from './../finish.vue'

  export default {
    props: ['modify_view', 'info', 'finish_title'],
    data() {
      return {
        btnText: '提交',
        stepTitle: '手机',
        currentStep: 1,
        vType: 'phone',
        request: {
          phone: this.info[1].value
        }
      }
    },
    methods: {
      /*
       ** 更换修改方式
       */
      switchValidate(type) {
        this.vType = type;

        if(type == 'phone'){
          this.request.phone = this.info[1].value;
          delete this.request.email;
        }
        else if(type == 'email'){
          this.request.email = this.info[0].value;
          delete this.request.phone;
        }
      },
      /*
       ** 下一步
       */
      next() {
        this.$emit('next');
        this.currentStep++;
      },
      /*
       ** 完成验证
       */
      finish() {
        this.$emit('finish');
        this.currentStep = 1;
      },
      errorResult(response) {
        this.$emit('errorResult', response);
      }
    },
    components: {
      steps,
      id_validate,
      bind_phone,
      finish
    }
  }
</script>

<style media="screen" lang="scss">
  .modify-phone{
    width: 810px;
    .finish{
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// modify_phone.vue?5b5c96b4